module.exports = __webpack_public_path__ + "static/3BHK-02-Dinnig-95c891be9e82fe60d5bd11f68de9a1ce.jpg";